// extracted by mini-css-extract-plugin
export default {"bottomButtons":"BusinessQRCode_bottomButtons__dFbq2","QRContainer":"BusinessQRCode_QRContainer__Y5II9"};